import { Injectable, signal, computed } from "@angular/core";
import { WarehouseStateModel } from "../Dto/WarehouseStateModel";
import { Warehouse } from "../Dto/WarehouseModel";
import { PaginationInfo } from "../Dto/WarehouseSearchResponse";
import { WarehouseSearchRequest } from "../Dto/WarehouseSearchRequest";

const initialState: WarehouseStateModel = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  },
  searchParams: {
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class WarehouseState {
  private readonly state = signal<WarehouseStateModel>(initialState);
  public readonly data = computed(() => this.state().data);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setWarehouses(data: Warehouse[], pagination: PaginationInfo): void {
    this.state.update((state) => ({
      ...state,
      data,
      pagination,
      loading: false,
      error: null,
    }));
  }

  setSearchParams(params: WarehouseSearchRequest): void {
    this.state.update((state) => ({
      ...state,
      searchParams: params,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  removeWarehouseFromState(warehouseId: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((warehouse) => warehouse.id !== warehouseId),
      pagination: {
        ...state.pagination,
        total: state.pagination.total - 1,
      },
    }));
  }

  addWarehouseToState(warehouse: Warehouse): void {
    this.state.update((state) => ({
      ...state,
      data: [warehouse, ...state.data],
      pagination: {
        ...state.pagination,
        total: state.pagination.total + 1,
      },
    }));
  }

  updateWarehouseInState(warehouse: Warehouse): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((storedWarehouse) =>
        (() => {
          if (storedWarehouse.id === warehouse.id) {
            return warehouse;
          }
          return storedWarehouse;
        })(),
      ),
      loading: false,
      error: null,
    }));
  }
}
